export const ExtensionEntryType = {
	DataConnector: 'dataConnector',
} as const;

/** Wire contracts for the Engine extension catalog endpoints. */
export interface ExtensionEntrySummary {
	id: string;
	version: string;
	type: typeof ExtensionEntryType[keyof typeof ExtensionEntryType];
	name: string;
	description?: string;
	icon: string;
	iconColor?: string;
}

export interface ExtensionSummary {
	id: string;
	version: string;
	name: string;
	description?: string;
	icon?: string;
	iconColor?: string;
	entries: ExtensionEntrySummary[];
}

export interface DataConnectorSummary {
	id: string;
	version: string;
	name: string;
	description?: string;
	icon: string;
	iconColor?: string;
	extensionId: string;
}
